<template>
<!-- eslint-disable -->
  <div>
      <BrandCreatorText></BrandCreatorText>
  </div>
</template>

<script>
import BrandCreatorText from '@/views/static/content/BrandCreatorText.vue';

export default {
  components: {
    BrandCreatorText,
  },
};
</script>

<style scoped>

</style>
